import React, { useState, useContext } from "react";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import userService from '../../../services/user.service';
import { sessionService } from '../../../sessionService/storage';
import { AuthContext } from '../../../contexts/AuthContext';
import { toastOptions } from '../../shared/selectStyle';

const Login = (props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const { setUser } = useContext(AuthContext);
    const [error, setError] = useState(false);
    const [userData, setUserData] = useState({
        email: "",
        password: ""
    });

    const handleChange = e => {
        setError(false);
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            let response = await userService.login(userData);
            sessionService.create(response);
            setUser(sessionService.getUser());
            if (sessionService.isAuth()) {
                if(response.user.isCompany){
                    history.push(`/dashboard/company/${response.user._id}`);
                }else{
                    history.push("/dashboard/folder");
                }
              
                toast.success("User is successfully loged !", toastOptions);
            }
        } else {
            setError(true);
        }
    }

    const validateForm = () => {
        return userData.email && userData.password.length > 3;
    }

    return (
        <form onSubmit={handleSubmit} className="auth-form">
            <h6 className="auth-title">{t('login.title')} </h6>
            <section>
                <div className="form-group custom-input">
                    <img src="/assets/images/user.svg" alt="Email" />
                    <input id='email' className="form-control" type="text" name="email" onChange={handleChange} placeholder={t('placeholder.email')} />
                </div>
                <div className="form-group custom-input">
                    <img src="/assets/images/password.svg" alt="Password" />
                    <input id='password' className="form-control" type="password" name="password" onChange={handleChange} placeholder={t('placeholder.password')} />
                </div>
                {error ? <div className="message-alert"><p>{t('requiredFields.msg')}</p></div> : null}
            </section>
            <button type="submit" className="btn btn-blue" > {t('signIn')}</button>
            <p className="auth-sub-desc"> {t('login.msg')} <span className="c-blue" onClick={() => props.switchForms('register')}>
                <strong>{t('signUp')}!</strong></span>
            </p>
        </form>
    )
}
export default Login;


// WEBPACK FOOTER //
// ./src/components/auth/loginComponent/login.js